<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T10:24:36+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
@Last modified by:   tom
@Last modified time: 2018-02-07T14:54:20+01:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template lang="html">
  <b-navbar
    id="top-navbar"
    toggleable="md"
    type="dark"
    variant="primary"
    fixed="top"
  >
    <b-container>
      <!-- VueBootstrap: "to" instead of "href" will use <router-link> -->
      <b-navbar-brand to="/#landing">
        <!-- image to use on narrow mobile screen -->
        <lzimg class="d-md-block d-lg-none d-xl-none" alt="[L]" src="@/assets/img/logo/Lorinthe-Icon-semi-transparant.svg" height="28" />
        <!-- image to use on wide screens -->
        <lzimg class="d-none d-lg-block d-xl-block" alt="[Lorinthe]" src="@/assets/img/logo/Lorinthe-Logo-semi-transparant.svg" height="28" />
      </b-navbar-brand>

      <!-- the hamburger menu on xs screens -->
      <b-navbar-toggle target="nav_collapse" />

      <b-collapse id="nav_collapse" is-nav>
        <!-- Left aligned nav items -->
        <b-navbar-nav />

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <!-- <router-link :to="{name:'Home'}" class="nav-item nav-link">{{ $t('def.home') }}</router-link> -->
          <!-- <router-link :to="{name:'Services'}" class="nav-item nav-link">
            {{ $t('services.label') }}
          </router-link> -->
          <router-link to="/#case-studies" class="nav-item nav-link">
            {{ $t('cases.label') }}
          </router-link>
          <!-- <router-link to="/#casestudies" class="nav-item nav-link" v-scroll-to="'#case-studies'">{{ $t('cases.label') }}</router-link> -->
          <!-- <router-link :to="{name:'Technology'}" class="nav-item nav-link">
            {{ $t('technology.label') }}
          </router-link> -->
          <!-- <router-link :to="{name:'Blog'}" class="nav-item nav-link">{{ $t('blog.label') }}</router-link> -->
          <router-link :to="{name:'Aboutus'}" class="nav-item nav-link">
            {{ $t('about_us.label') }}
          </router-link>
          <!-- <router-link :to="{name:'Prices'}" class="nav-item nav-link nav-last">{{ $t('prices.label') }}</router-link> -->
          <router-link to="/#contact" class="nav-item nav-link">
            {{ $t('contact.label') }}
          </router-link>

          <locale-switcher :locales="['en', 'nl']" :show-full="true" class="pl-4" />
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
}
</script>

<style lang="scss">

  // @import "../assets/style/theme.scss";

  #top-navbar {
    // little shadow line below
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3) !important;
    -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3) !important;
    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3) !important;
    .nav-link {
      text-align: right;
    }
  }

</style>
